import { useState } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { RemoveAnalysisContext } from '@/context/Context';
import { toolRoutes } from '@/routes/siteMaps';
import AnalysisModalProvider from './components/AnalysisModalProvider';
import ToolsBreadcrumb from '@/app/common/components/ToolsBreadcrumb';
import ToolTabs from '@/app/common/components/ToolTabs';
import useDomain from '@/hooks/useDomain';
import SubtleBadge from '@/components/common/SubtleBadge';

type NavRoute = {
  name: string;
  to: string;
  disabled?: boolean;
  children?: NavRoute[];
};

const AnalysisMain = () => {
  const { slug } = useParams<{ slug?: string }>();
  const location = useLocation();

  const { domain_slug, domain } = useDomain();
  const routes = toolRoutes.children.find(
    (item: { name: string }) => item.name === 'سرعت صفحه'
  ) as NavRoute | undefined;
  const [navItems] = useState(routes);

  const tabTo = (route: NavRoute) =>
    route.to.includes('history')
      ? `${route.to}/${domain_slug}/${domain}`
      : `${route.to}/${slug ? slug : 'last'}/${domain_slug}/${domain}`;

  const [analysisId, setAnalysisId] = useState('');
  const [status, setStatus] = useState(6);
  const [analysisUrl, setAnalysisUrl] = useState<string | boolean>('');
  const [show, setShow] = useState(false);

  return (
    <>
      <RemoveAnalysisContext.Provider
        value={{
          analysisId,
          analysisUrl,
          setAnalysisId,
          setAnalysisUrl,
          show,
          status,
          setStatus,
          setShow
        }}
      >
        <ToolsBreadcrumb
          parentName="سرعت صفحه"
          parentUrl={`/analysis/${domain_slug}/${domain}`}
          childs={[]}
        />
        <ToolTabs
          items={(navItems?.children ?? []).map(route => {
            const to = tabTo(route);
            const showNew =
              route.to === '/analysis/comparison' || route.to === '/analysis/crux';
            return {
              key: route.to,
              label: route.name,
              to: route.disabled ? '#' : to,
              disabled: route.disabled,
              state: { path: location.pathname, query: null },
              active:
                !route.disabled &&
                (location.pathname === to ||
                  location.pathname.startsWith(`${to}/`)),
              badge: showNew ? (
                <SubtleBadge bg="success" className="ms-1">
                  جدید
                </SubtleBadge>
              ) : undefined
            };
          })}
        />
        <AnalysisModalProvider>
          <Outlet />
        </AnalysisModalProvider>
      </RemoveAnalysisContext.Provider>
    </>
  );
};

export default AnalysisMain;
